import React from 'react'
import styled from '@emotion/styled'
import Loadable from '@loadable/component'

const LazySearch = Loadable(() => import(/* webpackChunkName: 'Search' */ '../Search'))

const SearchPanelWrapper = styled.div`
	background: ${({ theme }) => theme.colors.white};
	display: flex;
	flex-direction: column;
	position: absolute;
	justify-content: space-around;
	height: 100vh;
	padding-top: 75px;
	top: 0;
	width: 100%;
	left: ${({ searchStatus }) => (searchStatus ? '0px' : '-100%')};
	transition: all 0.8s ease;
	z-index: 6;

	${({ theme }) => theme.MQ.M} {
		width: 730px;
	}
`
const Back = styled.div`
	${({ theme }) => theme.ctas.default};
	margin-left: 2rem;
	bottom: 0;

	${({ theme }) => theme.MQ.S} {
		margin: 0 auto;
		width: 500px;
	}
`

/**
 * Search Page Overlay - When this is open, the search appears over the menu panel
 * @param {function} props.handleClosePanel :: handles panel slide out on click
 * @param {boolean} props.isSearchVisible :: flag to determine if the search panel is displayed
 * @param {boolean} props.showBackToMenu :: flag to determine if this panel accessed from the header
 */
export function SearchPanel({ handleClosePanel, isSearchVisible, showBackToMenu }) {
	return (
		<SearchPanelWrapper searchStatus={isSearchVisible}>
			{isSearchVisible && <LazySearch />}
			{
				/* Only show back to menu if user navigated via Hamburger Menu */
				showBackToMenu && <Back onClick={handleClosePanel}>Back to Menu</Back>
			}
		</SearchPanelWrapper>
	)
}
